import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "../thema/style";
import { connect } from "react-redux";
import { addCart } from "../store/actions/cart";

class AddCartButton extends Component {
  state = {
    opacity: 0.6,
    scale: 1,
    x: 0,
    y: 0,
    addCart: false,
    addCartSpanDisplay: "inline-block"
  };
  render() {
    return (
      <React.Fragment>
        <a
          className={this.state.addCart ? styles.addCart : null}
          href="#"
          onClick={e => {
            e.preventDefault();
            this.props.addCart({ ...this.props.product, quantity: 1 }, 1);
            this.setState(
              {
                addCart: true,
                addCartSpanDisplay: "none"
              },
              () => {
                const {
                  x: IMG_X,
                  y: IMG_Y,
                  width: IMG_W,
                  height: IMG_H
                } = this.props.img.current.getBoundingClientRect();

                const { x: CART_X, y: CART_Y } = this.props.cartPosition[
                  `cart${this.props.cartPosition.cart}Ref`
                ].current.getBoundingClientRect();

                this.setState(
                  {
                    opacity: 0.1,
                    scale: 0.5,
                    x: CART_X - IMG_X - IMG_W / 2,
                    y: CART_Y - IMG_Y - IMG_H / 4
                  },
                  () => {
                    setTimeout(() => {
                      this.setState(
                        {
                          opacity: 0.6,
                          scale: 1,
                          x: 0,
                          y: 0,
                          addCart: false
                        },
                        () => {
                          setTimeout(() => {
                            this.setState({
                              addCartSpanDisplay: "inline-block"
                            });
                          }, 200);
                        }
                      );
                    }, 700);
                  }
                );
              }
            );
          }}
        >
          <span style={{ display: this.state.addCartSpanDisplay }}>
            Sepete Ekle
          </span>{" "}
          <FontAwesomeIcon icon={["fas", "cart-plus"]} />
        </a>
        {this.state.addCart && (
          <div
            style={{
              opacity: this.state.opacity,
              zIndex: 1,
              marginTop: 50,
              position: "absolute",
              // left: 0,
              // top: 0,
              width: "100%",
              transition: "all 0.7s",
              // transform: `translateX(${this.state.x}px) translateY(${
              //   this.state.y
              // }px)`

              left: this.state.x,
              top: this.state.y,
              transform: `scale(${this.state.scale})`

              // transform: `translateX(${this.state.x -
              //   this.props.img.current.width}px) translateY(${this.state.y -
              //   this.props.img.current.height / 2}px)`
              // transform: `translateX(${
              //   this.state.x - this.props.img.current.width < 0
              //     ? 0
              //     : this.state.x - this.props.img.current.width
              // }px) translateY(${
              //   this.state.y - this.props.img.current.height / 2 < 0
              //     ? 0
              //     : this.state.y - this.props.img.current.height / 2
              // }px)`

              // { translateX: this.state.x - this.props.img.current.width },
              // {
              //   translateY: this.state.y - this.props.img.current.height / 2
              // }

              // display: "flex",
              // alignItems: "center",
              // justifyContent: "center"
            }}
          >
            <img
              src={this.props.img.current.src}
              style={{
                width: this.props.img.current.width,
                height: this.props.img.current.height
              }}
            />
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ cartPosition }) => {
  return {
    cartPosition
  };
};

const mapDispatchToProps = { addCart };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddCartButton);



// WEBPACK FOOTER //
// ./src/components/AddCartButton.js